import { useState } from "react";
import { Modal } from "react-bootstrap";
import { getImageUrl, isImage } from "../../../../utils";
import active_link from "../../../../svg/active-link.svg";

const sampleWork = ({removeURL = () => {}, showData = {}, handleClose = () => {}}) => {
    const [fullScreen, setFullScreen] = useState({show: false, url: '', type: 'image'});;
    const handleFullScreen = (e, url = "", type = "image") => {
        if(type === 'image') {
            if(isImage(url)) {
                setFullScreen({url: url, show: true, type})
            } else {
                window.open(url)
            }
        } else {
            setFullScreen({url: url, show: true, type})
        }
        handleClose(e);
    }

    const renderSamples = () => {
        return showData?.samples?.filter(a => a.uploadSamples).map((sample, index) => {
            return(
                <div key={sample.uploadSamples} class="col-6">
                    <div key={sample.uploadSamples} className="imgWrap mt-1">
                        <div className="imgWrap-opt">
                            <a>
                                <b className="icon-fullscreen" onClick={(e) => handleFullScreen(e, sample.uploadSamples)} />
                            </a>
                            <a>
                                <b className="icon-bin" onClick={(e) => removeURL(e, sample)} />
                            </a>
                        </div>
                        <img src={getImageUrl(sample.uploadSamples)} onerror="this.onerror=null; this.src='https://picsum.photos/200/300'" alt="#" />
                    </div>
                </div>

            )
        })
    }

    const workUrls = () => {
        return showData?.samples?.filter(a => a.url).map((sample, index) => {
            return(
                <div key={sample.url} className="col-6">
                    <div className="urlWrap">
                        {/* <b className="icon-link urlWrap-icon" /> */}
                        <img src={active_link} className="urlWrap-icon" alt="link" />
                        <p className="urlWrap-url">{sample.url}</p>
                        <div className="imgWrap-opt">
                            <a onClick={(e) => removeURL(e, sample)}><b class="icon-bin"></b></a>
                            <a onClick={(e) => handleFullScreen(e, sample.url, 'url')}><b class="icon-fullscreen"></b></a>
                        </div>
                    </div>
                </div>
            )
        })
    }

    return(
        <>
            <Modal dialogClassName="modal-dialog-centered modal-bg" show={showData.show} size='sm'>
                <div>
                    <div className="modal-header">
                        <h5 className="modal-title">View Samples</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={(e) => handleClose(e)}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="px-2 ps-0">
                        <div className="row">
                            {renderSamples()}
                            {workUrls()}
                        </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal id="fullScreen-modal" dialogClassName="modal-dialog-centered modal-bg" show={fullScreen.show} size='xl'>
                <div>
                    <div className="modal-header">
                        <button
                            type="button"
                            className="btn-close"
                            onClick={(e) => setFullScreen({show: false, url: ""})}
                        />
                    </div>
                    <div className="modal-body">
                        {fullScreen.type === 'url' ? <p>{fullScreen.url}</p> : <img src={fullScreen.url} alt="image" />}
                    </div>
                </div>
            </Modal>

        </>
    )
}

export default sampleWork;